var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTefilla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,89.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230 635 c-14 -8 -44 -14 -67 -15 -24 0 -43 -2 -43 -4 0 -2 13 -33 30 -68 16 -34 30 -69 30 -75 0 -30 28 -8 66 52 38 60 40 65 28 94 -7 17 -14 31 -16 31 -2 -1 -14 -7 -28 -15z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,89.000000) scale(0.100000,-0.100000)",
    fill: "#D6E4F5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230 645 c-14 -8 -46 -14 -72 -15 -57 0 -56 1 -17 -86 54 -121 58 -124 90 -62 11 24 33 55 47 70 25 28 25 28 7 68 -20 45 -20 45 -55 25z m44 -26 c12 -29 10 -34 -28 -94 -38 -60 -66 -82 -66 -52 0 6 -14 41 -30 75 -17 35 -30 66 -30 68 0 2 19 4 43 4 23 1 53 7 67 15 14 8 26 14 28 15 2 0 9 -14 16 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672 255 c-2 -128 4 -155 32 -155 5 0 2 6 -7 13 -14 10 -17 34 -20 142 l-3 130 -2 -130z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444 225 c0 -77 2 -107 3 -67 2 40 2 103 0 140 -2 37 -3 4 -3 -73z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,89.000000) scale(0.100000,-0.100000)",
    fill: "#2F7ED2",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M722 273 c-2 -125 -5 -153 -16 -153 -8 0 -17 12 -19 28 -4 27 -4 27 -6 -1 -1 -29 23 -47 40 -30 6 6 8 72 6 159 l-3 149 -2 -152z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 215 c0 -130 0 -130 25 -132 21 -1 22 -1 3 4 -22 4 -23 9 -26 131 l-3 127 1 -130z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 203 c-1 -61 1 -114 6 -116 4 -3 6 32 4 76 -4 141 -9 156 -10 40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 178 c-3 -53 -1 -94 3 -89 4 4 6 48 5 97 -3 89 -3 89 -8 -8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,89.000000) scale(0.100000,-0.100000)",
    fill: "#0C254C",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325 773 c3 -27 8 -65 11 -85 7 -46 -5 -49 -28 -8 -19 34 -31 36 -85 16 -21 -8 -62 -17 -92 -20 -86 -9 -91 -20 -48 -113 20 -43 39 -90 43 -106 3 -15 19 -38 35 -51 18 -15 27 -30 23 -40 -10 -26 16 -85 47 -107 28 -19 29 -23 23 -76 -5 -41 -4 -57 7 -63 22 -14 27 -3 34 66 8 66 8 66 -34 104 -50 46 -50 55 -6 139 62 116 70 120 104 53 28 -55 41 -141 41 -274 0 -111 1 -118 20 -118 48 0 19 355 -36 436 -26 38 -24 47 14 59 68 20 120 -117 130 -346 6 -127 10 -154 22 -154 23 0 26 212 5 332 -24 132 -84 213 -158 213 -22 0 -27 4 -24 18 7 23 25 111 30 145 4 26 3 27 -40 27 -44 0 -44 0 -38 -47z m-36 -152 c20 -39 20 -39 -9 -72 -16 -19 -37 -51 -46 -72 -28 -61 -50 -48 -95 57 -44 103 -45 99 18 100 27 1 57 7 68 14 32 19 43 14 64 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570 816 c0 -5 49 -119 60 -138 30 -53 51 -201 51 -368 0 -139 7 -190 26 -190 17 0 15 414 -2 454 -15 35 19 12 41 -29 28 -48 42 -121 50 -257 4 -60 10 -108 14 -108 48 0 33 279 -20 380 -7 14 -41 54 -75 90 -42 44 -67 82 -80 118 -15 42 -23 52 -42 52 -13 0 -23 -2 -23 -4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTefilla);
export default __webpack_public_path__ + "static/media/tefilla.b96946c8f9165e1e7575c920fc8bcd92.svg";
export { ForwardRef as ReactComponent };